import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function queryOutboundApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.outboundorderqueryapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/stockOutOrder/query"
          },
          {
            key: "apiDocDesc.proUrl",
            value:
              "https://sop.jtfulfillment.cn/gateway/edi/stockOutOrder/query"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/stockOutOrder/query"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/stockOutOrder/query"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc273"
            },
            {
              name: "serialnumber",
              type: "VARCHAR",
              require: "C",
              normal: "",
              describe: "apiDocDesc.serialnumberDesc274"
            },
            {
              name: "customerid",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc275"
            },
            {
              name: "command",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.commandDesc276"
            },
            {
              name: "startdate",
              type: "DATE",
              require: "C",
              normal: "",
              describe: "apiDocDesc.startdateDesc277"
            },
            {
              name: "enddate",
              type: "DATE",
              require: "C",
              normal: "",
              describe: "apiDocDesc.enddateDesc278"
            },
            {
              name: "pageNo",
              type: "int",
              require: "C",
              normal: "",
              describe: "apiDocDesc.pageNoDesc279"
            },
            {
              name: "pageSize",
              type: "int",
              require: "C",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc280"
            },
            {
              name: "ordertype",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.ordertypeDesc281"
            },
            {
              name: "status",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.statusDesc282"
            },
            {
              name: "country",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.countryDesc283"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "BOOLEAN",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc284"
            },
            {
              name: "reason",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.reasonDesc285"
            },
            {
              name: "total",
              type: "int",
              require: "",
              normal: "",
              describe: "apiDocDesc.totalDesc286"
            },
            {
              name: "startPage",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.startPageDesc287"
            },
            {
              name: "pageSize",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc288"
            },
            {
              name: "orderList",
              type: "VARCHAR",
              require: "",
              normal: "",
              describe: "apiDocDesc.orderListDesc289",
              children: [
                {
                  name: "customerid",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.customeridDesc290"
                },
                {
                  name: "txlogisticid",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.txlogisticidDesc291"
                },
                {
                  name: "mailno",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mailnoDesc292"
                },
                {
                  name: "platformNumber",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.platformNumberDesc400"
                },
                {
                  name: "created",
                  type: "DATETIME",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.createdDesc293"
                },
                {
                  name: "source",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.sourceDesc294"
                },
                {
                  name: "orderstatus",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.orderstatusDesc295"
                },
                {
                  name: "warehouseCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.warehouseCodeDesc296"
                },
                {
                  name: "businessMode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.businessModeDesc297"
                },
                {
                  name: "routeid",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.routeidDesc298"
                },
                {
                  name: "outboundtype",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.outboundtypeDesc299"
                },
                {
                  name: "transport",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.transportDesc300"
                },
                {
                  name: "goodstype",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.goodstypeDesc301"
                },
                {
                  name: "remark",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.remarkDesc302"
                },
                {
                  name: "carrier",
                  type: "VARCHAR",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.carrierDesc303"
                },
                {
                  name: "endTrackingNo",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.endTrackingNoDesc304"
                },
                {
                  name: "pickType",
                  type: "INT",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.pickTypeDesc305"
                },
                {
                  name: "label",
                  type: "VARCHAR",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.labelDesc306"
                },
                {
                  name: "stockTime",
                  type: "DATE",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.stockTimeDesc307"
                }
              ]
            },
            {
              name: "sender",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.senderDesc308",
              children: [
                {
                  name: "company",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.companyDesc309"
                },
                {
                  name: "name",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.nameDesc310"
                },
                {
                  name: "postcode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.postcodeDesc311"
                },
                {
                  name: "mailbox",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mailboxDesc312"
                },
                {
                  name: "mobile",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mobileDesc313"
                },
                {
                  name: "phone",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.phoneDesc314"
                },
                {
                  name: "countrycode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.countrycodeDesc315"
                },
                {
                  name: "prov",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.provDesc316"
                },
                {
                  name: "city",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.cityDesc317"
                },
                {
                  name: "area",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.areaDesc318"
                },
                {
                  name: "address",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.addressDesc319"
                }
              ]
            },
            {
              name: "receiver",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.receiverDesc320",
              children: [
                {
                  name: "company",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.companyDesc321"
                },
                {
                  name: "name",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.nameDesc322"
                },
                {
                  name: "mobile",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.mobileDesc323"
                },
                {
                  name: "postcode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.postcodeDesc324"
                },
                {
                  name: "country",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.countryDesc325"
                },
                {
                  name: "prov",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.provDesc326"
                },
                {
                  name: "city",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.cityDesc327"
                },
                {
                  name: "area",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.areaDesc328"
                },
                {
                  name: "address",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.addressDesc329"
                }
              ]
            },
            {
              name: "items",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.itemsDesc330",
              children: [
                {
                  name: "lineNo",
                  type: "int",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.lineNoDesc331"
                },
                {
                  name: "itemCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc332"
                },
                {
                  name: "itemName",
                  type: "VARCHAR",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.itemNameDesc333"
                },
                {
                  name: "number",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.numberDesc334"
                },
                {
                  name: "quantity",
                  type: "INT",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.quantityDesc335"
                },
                {
                  name: "snList",
                  type: "Array",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.snListDesc336",
                  children: [
                    {
                      name: "sn",
                      type: "String[]",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.snDesc337"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        command: 2,
        ordertype: "XSCK",
        status: "1",
        customerid: "DEV-TEST",
        serialnumber: "20240627202934571",
        warehouseCode: "SH.001"
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        traceId: "3daa4f2d17195395941078999e",
        responseitems: [
          {
            success: "true",
            reason: "",
            errorMsg: null,
            orderList: [
              {
                eccompanyid: "UPFOS",
                mailno: "20240627202934571",
                customerid: "DEV-TEST",
                txlogisticid: "20240627202934571",
                orderstatus: "待复核",
                warehouseCode: "SH.001",
                ordertype: "XSCK",
                paytype: null,
                routeid: "123",
                outboundtype: "C1",
                transport: "1018003",
                goodstype: null,
                itemsvalue: "100.7800",
                weight: null,
                totalquantity: "2",
                remark: "TESTING, JANGAN DILANJUT!!!",
                pricecurrency: "PHP",
                sender: {
                  company: null,
                  name: null,
                  postcode: null,
                  mailbox: null,
                  phone: null,
                  mobile: null,
                  countrycode: null,
                  prov: null,
                  city: null,
                  area: null,
                  address: null,
                  address1: null,
                  address2: null,
                  country: null
                },
                receiver: {
                  company: null,
                  name: "mick",
                  postcode: "155555",
                  phone: "**********7866",
                  mobile: "**********4590",
                  countrycode: null,
                  prov: "OCCIDENTAL-MINDORO",
                  city: "OCCIDENTAL-MINDORO-MAGSAYSAY",
                  area: "CALAWAG",
                  address: "Address101",
                  address1: null,
                  address2: "",
                  country: null,
                  idNumber: null,
                  idNumberUrl: null,
                  supplierCode: null,
                  shipTo: null
                },
                items: [
                  {
                    itemCode: "123456",
                    itemName: "123456",
                    englishName: null,
                    number: "1",
                    itemvalue: null,
                    pricecurrency: null,
                    itemurl: null,
                    hscode: null,
                    itemType: null,
                    ylsku: null,
                    desc: null,
                    sptype: null,
                    remark: null,
                    requestQty: null,
                    quantity: 1,
                    lockQuantity: 0,
                    saleQuantity: 0,
                    stockRemark: null,
                    unitLength: null,
                    unitWidth: null,
                    unitHeight: null,
                    isElectricity: null,
                    lineNo: null,
                    isGift: null,
                    inventoryType: null,
                    productDate: null,
                    produceCode: null,
                    batchCode: null,
                    reserved1: null,
                    snList: {
                      sn: ["iECUks0M8v"]
                    }
                  }
                ],
                cusname: null,
                transferFlag: null,
                transferType: null,
                covertemplate: null,
                saddressEn: null,
                carrier: "JT",
                label: "https://www.qq.com",
                pickType: "",
                stockTime: null,
                businessMode: "B2C",
                goodsValue: null,
                customerPo: null,
                verifyStatus: null,
                verifyResult: null,
                source: "*",
                createOrderTime: "2023-05-16 15:05:12",
                createOrderTimeDate: null,
                storeCode: "DIANXIAOMI-店铺编码",
                storeName: null,
                thirdCustomerCode: null,
                pickUp: null,
                offerFee: null,
                insuranceValue: null,
                insuranceCurrency: null,
                useInsurance: null,
                code: "20240627202934571",
                shippingMethod: 9999,
                routeCode: null,
                packageCenterCode: null,
                isCod: null,
                expressBillFlag: null,
                platformNumber: "20240627202934571",
                payTime: null,
                created: "2024-06-27T20:29:35",
                storerKey: null,
                sourceSystem: null,
                outBizNo: null,
                transportMode: null,
                reserved1: null,
                businessType: null
              }
            ],
            entryOrderCode: null,
            entryOrderId: null
          }
        ]
      }
    }
  };
}
